import { IPlaceCategory } from "../../../components/FacilityManager/Domain/Types/FloorPlan/PlaceCategory.type";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

export function useRemoteFetchPlaceCategory(options?: { enabled?: boolean }) {
  return useRemoteQuery<IPlaceCategory[]>({
    queryKey: "place-category",
    url: "/place-category",
    enabled: options?.enabled
  });
}
